(() => {
  const KEY = 'lsCompare';
  const MAX = 4;
  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch {
      return [];
    }
  };
  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch {}
    sync();
    document.dispatchEvent(new CustomEvent('ls:compare', { detail: list }));
  };

  const text = document.documentElement.dataset;
  const bar = document.createElement('div');
  bar.className = 'ls-cmpbar';
  bar.hidden = true;
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', text.lsTxtCompare || '');
  bar.innerHTML = '<div class="ls-cmpbar__in"><span class="ls-dots" data-ls-cmp-count aria-hidden="true"></span><span class="ls-cmpbar__text" aria-live="polite"></span><a class="button" href="/cart?view=compare"></a><button type="button" class="ls-cmpbar__clear"></button></div>';
  bar.querySelector('a').textContent = text.lsTxtCompare || '';
  bar.querySelector('.ls-cmpbar__clear').textContent = text.lsTxtClear || '';
  document.body.append(bar);
  bar.querySelector('.ls-cmpbar__clear').addEventListener('click', () => write([]));

  function sync() {
    const list = read();
    document.querySelectorAll('[data-ls-compare]').forEach((btn) => {
      const on = list.includes(btn.dataset.lsCompare);
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', on);
    });
    const onPage = location.search.includes('view=compare');
    bar.hidden = !list.length || onPage;
    if (list.length && !onPage) {
      const count = bar.querySelector('[data-ls-cmp-count]');
      if (count.dataset.n !== String(list.length) && window.lsDots) {
        count.dataset.n = list.length;
        window.lsDots(count, list.length);
      }
      bar.querySelector('.ls-cmpbar__text').textContent = list.length >= MAX ? text.lsTxtMax : text.lsTxtSelected;
    }
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest?.('[data-ls-compare]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    const handle = btn.dataset.lsCompare;
    const list = read();
    if (list.includes(handle)) write(list.filter((h) => h !== handle));
    else if (list.length < MAX) write([...list, handle]);
  }, true);

  let timer;
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(sync, 80);
  }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  window.lsCompare = { read, write };
  sync();

  document.addEventListener('click', (event) => {
    const box = event.target.closest?.('.account-button');
    if (!box || event.target.closest('shopify-account')) return;
    box.querySelector('shopify-account')?.shadowRoot?.querySelector('button')?.click();
  });

  const vatSync = () => {
    const mode = document.documentElement.dataset.lsVat || 'both';
    document.querySelectorAll('[data-ls-vat-set]').forEach((btn) => {
      const on = btn.dataset.lsVatSet === mode;
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', on);
    });
  };
  document.addEventListener('click', (event) => {
    const btn = event.target.closest?.('[data-ls-vat-set]');
    if (!btn) return;
    const mode = btn.dataset.lsVatSet;
    if (mode === 'both') delete document.documentElement.dataset.lsVat;
    else document.documentElement.dataset.lsVat = mode;
    try {
      localStorage.setItem('lsVat', mode);
    } catch {}
    vatSync();
  });
  let vatTimer;
  new MutationObserver(() => {
    clearTimeout(vatTimer);
    vatTimer = setTimeout(vatSync, 80);
  }).observe(document.body, { childList: true, subtree: true });
  vatSync();

  const recent = document.querySelector('[data-ls-recent]');
  if (recent) {
    let ids = [];
    try {
      ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
    } catch {}
    ids = ids.filter((id) => id !== recent.dataset.current).slice(0, 4);
    if (ids.length) {
      const url = new URL('/search', location.origin);
      url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
      url.searchParams.set('type', 'product');
      url.searchParams.set('section_id', 'ls-recent-data');
      fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = recent.querySelector('[data-ls-recent-grid]');
          ids.forEach((id) => {
            const card = doc.querySelector(`[data-id="${id}"]`);
            if (card) grid.append(card);
          });
          recent.hidden = !grid.childElementCount;
        })
        .catch(() => {});
    }
  }
})();
